import { render, staticRenderFns } from "./addBackDialog.vue?vue&type=template&id=4ce74311&scoped=true"
import script from "./addBackDialog.vue?vue&type=script&lang=js"
export * from "./addBackDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce74311",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ce74311')) {
      api.createRecord('4ce74311', component.options)
    } else {
      api.reload('4ce74311', component.options)
    }
    module.hot.accept("./addBackDialog.vue?vue&type=template&id=4ce74311&scoped=true", function () {
      api.rerender('4ce74311', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/components/addBackDialog.vue"
export default component.exports